import { Component, OnInit} from '@angular/core';
import { OceanLineService, OceanLine, TableHeader, PagerService, CommonService } from 'app/services';
import { Subscription } from 'rxjs/Subscription';
import { Util } from '../../utils/util'
import _ from 'lodash';

@Component({
    selector: 'operators-list',
    templateUrl: 'operators-list.html',
  })

export class OperatorsList implements OnInit{

    condition:ConditionSearch = new ConditionSearch();
    tabIndex:number = 0;
    getOceanLineListSub:Subscription;
    
    oceanLineList:Array<OceanLine> = new Array();
    allOceanLineList: Array<OceanLine> = new Array();
    pager: any = {};
    pagedItems: Array<OceanLine> = new Array();
    headerList:Array<TableHeader> = new Array();

    clickedId:number = 0;

    constructor(
        private oceanLineService:OceanLineService,
        private pagerService: PagerService,
        private commonService:CommonService){

    }

    ngOnInit(){
        this.makeHeader();
        this.getOceanLineList(true);
    }

    makeHeader(){
        this.headerList = new Array<TableHeader>();
        this.headerList.push(new TableHeader(0, 'id', 'No.', true));
        this.headerList.push(new TableHeader(1, 'lineCd', '코드명', true));
        this.headerList.push(new TableHeader(2, 'lineNm', '운영사 명', true));
        this.headerList.push(new TableHeader(3, 'lineNm2', '운영사 명2', true));
        this.headerList.push(new TableHeader(4, 'lineNmKr', '운영사 명(KR)', true));
        this.headerList.push(new TableHeader(5, 'cntryCd', '국가 코드', true));
        this.headerList.push(new TableHeader(6, 'alliance', '협력', true));
        this.headerList.push(new TableHeader(7, 'corpId', '회사 아이디', true));
    }

    getOceanLineList(isInit:boolean){

        if(!this.oceanLineService.ingFlag) this.oceanLineService.getOceanLineList();
        this.getOceanLineListSub = this.oceanLineService.lineListEe.subscribe(
            data =>{
                this.oceanLineList = data;
                this.allOceanLineList = data;
                if(!isInit){
                    this.searchOceanLine();
                }else{
                    this.setPage(1);
                }
            }
        )
    }

    searchOceanLine(event?) {
       
        if(event && event.keyCode != 13) return ;

        var filterValue = this.condition.text;

        if(this.allOceanLineList.length < 1) return;

        this.oceanLineList = _.filter(this.allOceanLineList, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });
        
        if(event) this.setPage(1);
        else this.setPage(this.pager.currentPage);       
    }   

    setPage(page:number){
        
        this.pager = this.pagerService.getPager(this.oceanLineList.length, page, 20);

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager.totalPages) {
          this.pager = this.pagerService.getPager(this.oceanLineList.length, this.pager.totalPages);
        }
    
        this.pagedItems = this.oceanLineList.slice(this.pager.startIndex, this.pager.endIndex + 1);

    }

}

class ConditionSearch{
    text:string = "";
}


// WEBPACK FOOTER //
// ./src/app/containers/operators/operators-list.ts